import { Capacitor } from '@capacitor/core';

const getHost = () => {
  if (Capacitor.isNativePlatform()) {
    return process.env.REACT_APP_API_URL;
  }

  return process.env.NODE_ENV === 'development' 
    ? 'http://localhost:8888' 
    : '';
};

const host = getHost();

// Directorio de todas las rutas de la aplicación, con su path y method.
const apiPaths = {
  // --- Rutas Generales ---
  resourcesApi:                 { path: '/api/resources', method: 'GET' },
  reprogramaApi:                { path: '/api/reprograma/clarification-call', method: 'POST' },
  manifiestaApi:                { path: '/api/manifiesta/clarification-call', method: 'POST' },
  notificationsApi:             { path: '/api/app/notification', method: 'GET' },

  // --- Rutas de Autenticación ---
  auth_login:                   { path: '/api/auth/login', method: 'POST' },
  auth_logout:                  { path: '/api/auth/logout', method: 'POST' },
  auth_signup:                  { path: '/api/auth/signup', method: 'POST' },
  verify_token:                 { path: '/api/auth/verifyToken', method: 'GET' },
  refresh_token:                { path: '/api/auth/refreshToken', method: 'POST' },
  auth_verifyEmail:             { path: '/api/auth/verifyEmail', method: 'GET' },
  auth_password_reset:          { path: '/api/auth/password/reset', method: 'POST' },
  auth_password_request:        { path: '/api/auth/password/request', method: 'POST' },

  user_settings_update:        { path: '/api/user/settings/update', method: 'POST' },

  // --- Rutas de Pagos ---
  payment_confirm:              { path: '/api/payment/confirm', method: 'POST' },

  // --- Rutas de Actividades Genéricas ---
  sync_guest_progress:          { path: '/api/activity/syncGuestProgress', method: 'POST' },
  activity_getBeliefThreshold:  { path: '/api/activity/getBeliefThreshold', method: 'GET' },
  activity_saveBeliefThreshold: { path: '/api/activity/saveBeliefThreshold', method: 'POST' },
  activity_deleteBeliefThresholdGoal: { path: '/api/activity/deleteBeliefThresholdGoal', method: 'POST' },
  activity_markAsComplete:      { path: '/api/activity/markAsComplete', method: 'POST' },
  activity_getCompletionStatus: { path: '/api/activity/getCompletionStatus', method: 'GET' },
  
  // --- RUTAS PARA LA ACTIVIDAD DE 12 ÁREAS ---
  activity_getRatings:          { path: '/api/activity/getActivityRatings', method: 'GET' },
  activity_saveRating:          { path: '/api/activity/saveRating', method: 'POST' },

  // --- RUTAS PARA ACTIVIDAD DE CONCIENTIZACIÓN / VISIÓN FUTURA ---
  activity_getAreaDefinitions:  { path: '/api/activity/getAreaDefinitions', method: 'GET' },
  activity_saveAreaDefinition:  { path: '/api/activity/saveAreaDefinition', method: 'POST' },

  // --- RUTAS PARA 7 NIVELES DE PROFUNDIDAD ---
  activity_getDeepWhyPrerequisites: { path: '/api/activity/getDeepWhyPrerequisites', method: 'GET' },
  activity_saveWhySelection:    { path: '/api/activity/saveWhySelection', method: 'POST' },
  activity_saveWhyAnswer:       { path: '/api/activity/saveWhyAnswer', method: 'POST' },

  // --- RUTAS PARA MEDITACIÓN ---
  meditation_saveRevelation:    { path: '/api/activity/saveRevelation', method: 'POST' },
  meditation_getRevelations:    { path: '/api/activity/getRevelations', method: 'GET' },
  
  // --- RUTA PARA LEADS ---
  leads_add:                    { path: '/api/leads', method: 'POST' },
  leads_action:                 { path: '/api/leads/action', method: 'POST' },
  log_track:                    { path: '/log/track', method: 'POST' },

  get_duration:                 { path: '/api/products/duration', method: 'POST' },

  products_management:          { path: '/api/products/management', method: 'POST' },
  send_news:                    { path: '/api/news', method: 'POST' },
  subscriptions_cancel:         { path: '/api/subscriptions/cancel', method: 'POST' },
  
  // --- RUTAS DE USUARIO Y PRODUCTOS (NUEVA SECCIÓN) ---
  user_get_products:             { path: '/api/user/products', method: 'GET' },
  user_consume_product:          { path: '/api/user/products/credit', method: 'POST' },

  comments_get_by_thread:       { path: '/api/comments/thread', method: 'GET' }, 
  comments_post:                { path: '/api/comments', method: 'POST' },
  comments_vote:                { path: '/api/comments/vote', method: 'POST' },

  upload_file:                { path: '/api/files/upload', method: 'POST' },
  get_files:                { path: '/api/files/get', method: 'GET' },

  // --- RUTA CONSTANTE ---
  auth_constant:                { path: 'constant', method: 'CONSTANT' },
};

const excludedGetRoutes = new Set([
  // Actualmente no hay excepciones.
]);

const baseUrls = Object.fromEntries(
  Object.entries(apiPaths).map(([key, value]) => [key, {
    path: `${host}${value.path}`,
    method: value.method
  }])
);

const urlHandler = {
  get(target, prop) {
    if (!(prop in target)) {
      return undefined;
    }
    
    const { path, method } = target[prop];

    if (method === 'GET' && !excludedGetRoutes.has(prop)) {
      const separator = path.includes('?') ? '&' : '?';
      return `${path}${separator}_=${new Date().getTime()}`;
    }
    
    return path;
  }
};

const UrlConfig = new Proxy(baseUrls, urlHandler);

export default UrlConfig;